export default "__VITE_ASSET__333d530c__"